module.exports = __webpack_public_path__ + "static/gh-mobile-7187fc08b18066499fbfb69493d93d4e.png";